import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  privileges: [],
  homescreen: [],
  taskrpm: [],
  rpm: [],
  Payment:[],
    qa: []
};

const userPrivilegesSlice = createSlice({
  name: "userPrivileges",
  initialState,
  reducers: {
    // PRIVILEGES
    setPrivileges: (state, action) => {
      state.privileges = action.payload;
    },
    addPrivilege: (state, action) => {
      if (!state.privileges.includes(action.payload)) {
        state.privileges.push(action.payload);
      }
    },
    removePrivilege: (state, action) => {
      state.privileges = state.privileges.filter(p => p !== action.payload);
    },
    clearPrivileges: (state) => {
      state.privileges = [];
    },
setQa: (state, action) => {
  state.qa = action.payload;
},
addQa: (state, action) => {
  if (!state.qa.includes(action.payload)) {
    state.qa.push(action.payload);
  }
},
removeQa: (state, action) => {
  state.qa = state.qa.filter(p => p !== action.payload);
},
clearQa: (state) => {
  state.qa = [];
},
    // HOMESCREEN
    setHomescreen: (state, action) => {
      state.homescreen = action.payload;
    },
    addHomescreen: (state, action) => {
      if (!state.homescreen.includes(action.payload)) {
        state.homescreen.push(action.payload);
      }
    },
    removeHomescreen: (state, action) => {
      state.homescreen = state.homescreen.filter(p => p !== action.payload);
    },
    clearHomescreen: (state) => {
      state.homescreen = [];
    },
setPayment: (state, action) => {
  state.Payment = action.payload;
},
addPayment: (state, action) => {
  if (!state.Payment.includes(action.payload)) {
    state.Payment.push(action.payload);
  }
},
removePayment: (state, action) => {
  state.Payment = state.Payment.filter(p => p !== action.payload);
},
clearPayment: (state) => {
  state.Payment = [];
},
    // TASKRPM
    setTaskrpm: (state, action) => {
      state.taskrpm = action.payload;
    },
    addTaskrpm: (state, action) => {
      if (!state.taskrpm.includes(action.payload)) {
        state.taskrpm.push(action.payload);
      }
    },
    removeTaskrpm: (state, action) => {
      state.taskrpm = state.taskrpm.filter(p => p !== action.payload);
    },
    clearTaskrpm: (state) => {
      state.taskrpm = [];
    },

    // RPM
    setRpm: (state, action) => {
      state.rpm = action.payload;
    },
    addRpm: (state, action) => {
      if (!state.rpm.includes(action.payload)) {
        state.rpm.push(action.payload);
      }
    },
    removeRpm: (state, action) => {
      state.rpm = state.rpm.filter(p => p !== action.payload);
    },
    clearRpm: (state) => {
      state.rpm = [];
    },
  }
});

export const {
  setPrivileges,
  addPrivilege,
  removePrivilege,
  clearPrivileges,
  setHomescreen,
  addHomescreen,
  removeHomescreen,
  setQa,
addQa,
removeQa,
clearQa,
  clearHomescreen,
  setTaskrpm,
  addTaskrpm,
  removeTaskrpm,
  clearTaskrpm,
  setRpm,
  addRpm,
  removeRpm,
  clearRpm,
    setPayment,
  addPayment,
  removePayment,
  clearPayment
} = userPrivilegesSlice.actions;

export default userPrivilegesSlice.reducer;
